import { WhatsappLogo } from "@phosphor-icons/react";

const WA_URL = "https://wa.me/527223947826?text=Hola%2C%20quiero%20m%C3%A1s%20informaci%C3%B3n%20de%20la%20Iglesia%20Viento%20de%20Gracia";

const WhatsAppButton = () => (
  <a
    href={WA_URL}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Escríbenos por WhatsApp"
    data-testid="whatsapp-float-btn"
    className="group fixed bottom-6 right-6 z-40 flex items-center gap-0 border border-white/15 bg-ink/85 p-3.5 text-fire backdrop-blur-md transition-colors duration-300 hover:border-fire hover:bg-fire hover:text-ink"
  >
    <WhatsappLogo size={20} weight="regular" />
    <span className="max-w-0 overflow-hidden whitespace-nowrap text-[10px] font-medium uppercase tracking-[0.25em] transition-all duration-500 group-hover:ml-2.5 group-hover:max-w-[180px]">
      Escríbenos
    </span>
  </a>
);

export default WhatsAppButton;
